import React from "react";
import "./CssFiles/footer.css";
import { AiOutlineHome } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { delete_portfolio } from "../redux/features/portfolioSlice";

const Footer = () => {
  const dispatch = useDispatch();
  const { user, token, isLoading } = useSelector(
    (state) => state.portfolio.auth
  );
  const { _id, user_id } = useSelector((state) => state.portfolio.data);
  const navigate = useNavigate();

  const handleDelete = async (e) => {
    e.preventDefault();
    try {
      const config = {
        headers: {
          authtoken: token,
        },
      };

      const response = await axios.post(
        `https://importfolio-backend.onrender.com/portfolio/delete/${_id}`,
        {},
        config
      );
      if (response.data === "Success") {
        dispatch(delete_portfolio());
        navigate("/");
      } else {
        navigate("/pageDoesn'tExist");
      }
    } catch (error) {
      console.error("Failed to delete the portfolio:", error);
      navigate("/error");
    }
  };

  return (
    <section className="footer__copy">
      <div
        className="footer__content"
        style={{ display: "flex", alignItems: "center" }}
      >
        {!isLoading && user && token && user.uid === user_id && (
          <>
            <button
              className="buttonn"
              onClick={() => navigate(`/edit/${_id}`)}
              aria-label="Edit ImportFolio"
            >
              Edit ImportFolio
            </button>
            <button
              className="delete buttonn"
              onClick={handleDelete}
              aria-label="Delete ImportFolio"
            >
              Delete ImportFolio
            </button>
          </>
        )}
      </div>
      {!isLoading && user && token && user.uid === user_id && (
        <div className="back__home">
          <div style={{ display: "flex" }}>
            <button
              className="buttonn"
              style={{ display: "flex", alignItems: "center" }}
              onClick={() => navigate("/")}
              aria-label="Back to home"
            >
              Back to home
              <AiOutlineHome className="home__icon" />
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Footer;
